import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  voucherList: {
    list: {
      data: [],
      total: 0,
    },
  },
  campaignList: {
    list: {
      data: [],
      total: 0,
    },
  },
  campaign: {
    data: {},
  },
  redemptionList: {
    list: {
      data: [],
      total: 0,
    },
  },
  redemption: {
    data: {},
  },
  voucherData: {},
  accumulateCalculationList: {
    list: {
      data: [],
      total: 0,
    },
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
